import { ReactElement, useState } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'
import Box from '@mui/material/Box'
import { Typography } from '@mui/material'
import { Modal } from 'components'
import { successToast } from 'utils/toastService'
import { sitesDetailsService } from 'services/sitesDetailsService'
import { useRefreshUser } from '../../../../../store'

interface Props {}

const useDeleteCompanyModal = ({}: Props): [
  ReactElement,
  (args: any) => void,
] => {
  const queryClient = useQueryClient()
  const refreshUser = useRefreshUser()

  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [companyId, setCompanyId] = useState<string>()
  const { deleteSite } = sitesDetailsService()

  const { mutate: deleteCompanyMutation } = useMutation(deleteSite, {
    onSuccess: (data) => {
      queryClient.invalidateQueries('fetch-companies')
      toggleModal()
      refreshUser()
      successToast(data?.detail ? data.detail : 'Site deleted successfully')
    },
    onError: (error: { detail?: string }) => {
      toggleModal()
      toast.error(
        error?.detail
          ? error.detail
          : 'Site has attached data and can`t be deleted'
      )
    },
  })

  const onClick = () => {
    deleteCompanyMutation(companyId)
  }

  const toggleModal = () => setIsOpen(!isOpen)

  return [
    <Modal
      isOpen={isOpen}
      title={'Delete Site'}
      okButtonType="submit"
      onConfirm={onClick}
      onClose={toggleModal}
      onConfirmButtonText="Ok"
    >
      <Box display={'flex'} flexDirection="column" px={'30px'}>
        <Typography
          fontSize="22px"
          fontWeight={'900'}
          align="center"
          width={'320px'}
        >
          Are you sure you want to delete this site ?
        </Typography>
      </Box>
    </Modal>,
    (id: string) => {
      toggleModal()
      setCompanyId(id)
    },
  ]
}

export default useDeleteCompanyModal
